import { render, staticRenderFns } from "./snippet-integration-instructions.vue?vue&type=template&id=0260db66"
import script from "./snippet-integration-instructions.vue?vue&type=script&lang=js"
export * from "./snippet-integration-instructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports